import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  Text,
  WarningIcon,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

import { useStore } from '../store/useErrorContributionModal.store';

const headerText = 'Something Went Wrong';
const description = 'Please try again.';

export const ErrorContributionModal = () => {
  const { t } = useTranslation();
  const visible = useStore((store) => store.modalVisible);
  const onSetVisible = useStore((store) => store.handleChangeVisibility);
  return (
    <ModalWrapper testId="ErrorContributionModal" visible={visible} onSetVisible={onSetVisible}>
      <Box align="center" pad={{ vertical: 'spacing24', horizontal: 'spacing128' }}>
        <WarningIcon size="48px" />
        <Text
          data-testid="ErrorContributionModal_modal_header"
          margin={{ vertical: 'spacing12' }}
          textAlign="center"
          size="24px"
          weight={700}
        >
          {headerText}
        </Text>

        <Text
          data-testid="ErrorContributionModal_modal_help-text"
          margin={{ bottom: 'spacing24' }}
          textAlign="center"
        >
          {description}
        </Text>
        <AppButton
          testId="ErrorContributionModal_modal"
          onClick={() => onSetVisible(false)}
          width="200px"
        >
          {t('Got It!')}
        </AppButton>
      </Box>
    </ModalWrapper>
  );
};
